export default "__VITE_ASSET__DVlPez84__"